import React from "react";
import { motion } from "framer-motion";
import { Box, Grid, Typography, Container } from "@mui/material";

// import HOMEGRAPHICS from "../../assets/Graphics/HomeGraphics.png";
import HOMEGRAPHICS from "../../assets/images/About/about-logo.png";
import EXPERIENCE from "../../assets/images/Home/experience.png";
import GLOBAL from "../../assets/images/Home/global-safety.png";
import KNOWLEDGEICN from "../../assets/images/Home/collaboration.png";
// import logo from "";

// Refined animation variants for smoother and more responsive experience
const imageVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

const boxVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
      delay: i * 0.18 + 0.3,
    },
  }),
};

const WhatSetAcross = () => {
  return (
    <Box>
      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          // py: { xs: 3, md: 6 },
        }}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          alignItems="center"
          justifyContent="space-around"
        >
          {/* right Side - Image */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              maxWidth: { xs: "100%", md: 600 },
              mb: { xs: 3, md: 0 },
              order: { xs: 2, md: 1 },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <motion.div
              variants={imageVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              style={{ width: "100%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  component="img"
                  src={HOMEGRAPHICS}
                  alt="Across Visual"
                  sx={{
                    width: "100%",
                    maxWidth: { xs: "20rem", sm: "26rem", md: "30rem" },
                    borderRadius: 2,
                    objectFit: "contain",
                    height: { xs: "14rem", sm: "20rem", md: "26rem" },
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
          {/* left Side - Text Boxes */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              px: { xs: 1, sm: 3, md: 0 },
              maxWidth: { xs: "100%", md: 500 },
              order: { xs: 1, md: 2 },
            }}
          >
            <Box mb={3}>
              {/* <Typography
                variant="h4"
                title="What sets Across Assist apart?"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "1.5rem", sm: "2rem", md: "2.3rem" },
                  fontFamily: '"Poppins", sans-serif',
                  mb: 1,
                }}
              >
                What sets Across Assist apart?
              </Typography> */}
            </Box>

            {[
              {
                icon: EXPERIENCE,
                title: "A Decade of Expertise You Can Trust",
                description:
                  "A proven track record in assistance services — across healthcare, mobility, and gadgets.",
              },
              {
                icon: GLOBAL,
                title: "Global Network, Trusted by Leaders",
                description:
                  "Core partner to leading assistance brands, blending local precision with global reach.",
              },
              {
                icon: KNOWLEDGEICN,
                title: "Tech-Driven Transparency",
                description:
                  "Real-time CRM, AI chatbots, and live tracking — powering faster, smarter, and more accountable support.",
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                variants={boxVariants}
                initial="hidden"
                whileInView="visible"
                custom={index}
                viewport={{ once: true, amount: 0.2 }}
                style={{ width: "100%" }}
              >
                <Box
                  display="flex"
                  alignItems="flex-start"
                  mb={2.5}
                  sx={{
                    flexDirection: { xs: "row", sm: "row" },
                  }}
                >
                  <Box
                    sx={{
                      minWidth: 40,
                      minHeight: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={`${item.title} icon`}
                      style={{
                        height: 40,
                        width: 40,
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </Box>
                  <Box ml={2} flex={1}>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: {
                          xs: "1.05rem",
                          sm: "1.15rem",
                          md: "1.2rem",
                        },
                        fontWeight: 500,
                        mb: 0.5,
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: { xs: "0.92rem", sm: "1rem" },
                        color: "text.secondary",
                        lineHeight: 1.6,
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WhatSetAcross;
